(() => {
  function stockists(root) {
    if (root.dataset.pagesBound) return;
    root.dataset.pagesBound = 'true';
    const input = root.querySelector('[data-stockist-search]');
    const clear = root.querySelector('[data-stockist-clear]');
    const count = root.querySelector('[data-stockist-count]');
    const empty = root.querySelector('[data-stockist-empty]');
    const entries = [...root.querySelectorAll('[data-stockist-entry]')];
    function update() {
      const query = input.value.trim().toLocaleLowerCase();
      let visible = 0;
      for (const entry of entries) {
        entry.hidden = !entry.dataset.searchText.toLocaleLowerCase().includes(query);
        if (!entry.hidden) visible += 1;
      }
      root.querySelectorAll('[data-stockist-region]').forEach(region => {
        region.hidden = ![...region.querySelectorAll('[data-stockist-entry]')].some(entry => !entry.hidden);
      });
      root.querySelectorAll('[data-stockist-city]').forEach(city => {
        city.hidden = ![...city.querySelectorAll('[data-stockist-entry]')].some(entry => !entry.hidden);
      });
      count.textContent = count.dataset.countTemplate.replace('__COUNT__', String(visible));
      empty.hidden = visible > 0;
      clear.hidden = !query;
    }
    input.addEventListener('input', update);
    clear.addEventListener('click', () => { input.value = ''; update(); input.focus(); });
    update();
  }

  function gifts(root) {
    if (root.dataset.pagesBound) return;
    root.dataset.pagesBound = 'true';
    const form = root.querySelector('[data-o2o-gift-form]');
    if (!form) return;
    const variant = form.querySelector('[data-gift-variant]');
    const message = form.querySelector('[data-gift-message]');
    const recipient = form.querySelector('[data-gift-recipient]');
    const sender = form.querySelector('[data-gift-sender]');
    const delivery = form.querySelector('[data-gift-date]');
    const isoLocalDate = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    const now = new Date();
    const latest = new Date(now);
    latest.setDate(now.getDate() + 90);
    delivery.min = isoLocalDate(now);
    delivery.max = isoLocalDate(latest);
    form.querySelector('[data-gift-offset]').value = String(now.getTimezoneOffset());
    function text(selector, value) { root.querySelectorAll(selector).forEach(node => { node.textContent = value; }); }
    function update() {
      const option = variant.selectedOptions[0];
      text('[data-gift-amount-preview]', option?.dataset.price || '');
      text('[data-gift-message-preview]', message.value.trim() || root.dataset.defaultMessage);
      text('[data-gift-recipient-preview]', recipient.value.trim() || root.dataset.recipientPlaceholder);
      text('[data-gift-sender-preview]', sender.value.trim() || root.dataset.senderPlaceholder);
      root.querySelectorAll('[data-gift-variant-button]').forEach(button => {
        const active = button.dataset.giftVariantButton === variant.value;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      root.querySelectorAll('[data-gift-submit]').forEach(button => {
        const available = option?.dataset.available === 'true';
        button.disabled = !available || form.dataset.adding === 'true';
        button.textContent = available ? button.dataset.readyLabel : button.dataset.unavailableLabel;
      });
    }
    root.querySelectorAll('[data-gift-design]').forEach(button => button.addEventListener('click', () => {
      form.querySelector('[data-gift-design-input]').value = button.dataset.designLabel;
      form.querySelector('[data-gift-design-id]').value = button.dataset.designId;
      root.querySelectorAll('[data-gift-artwork]').forEach(artwork => {
        artwork.src = button.dataset.artworkSrc;
        artwork.alt = button.dataset.designLabel;
      });
      text('[data-gift-artwork-label]', button.dataset.designLabel);
      root.querySelectorAll('[data-gift-design]').forEach(item => {
        item.classList.toggle('is-active', item === button);
        item.setAttribute('aria-pressed', String(item === button));
      });
    }));
    root.querySelectorAll('[data-gift-variant-button]').forEach(button => button.addEventListener('click', () => { variant.value = button.dataset.giftVariantButton; update(); }));
    form.addEventListener('input', update);
    variant.addEventListener('change', update);
    update();
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-o2o-stockists]').forEach(stockists);
    scope.querySelectorAll('[data-o2o-gift]').forEach(gifts);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
